import { z } from 'zod'

/**
 * Whether a key, an envelope, and everything hanging off it are real (`live`)
 * or for integration testing (`test`). The two modes of one tenant never see
 * each other's data.
 */
export const TENANT_MODES = ['live', 'test'] as const

export const tenantModeSchema = z.enum(TENANT_MODES)

export type TenantMode = z.infer<typeof tenantModeSchema>

export const PRISMA_TENANT_MODES = ['LIVE', 'TEST'] as const

export type PrismaTenantMode = (typeof PRISMA_TENANT_MODES)[number]

export const TENANT_MODE_FROM_PRISMA = {
  LIVE: 'live',
  TEST: 'test',
} as const satisfies Record<PrismaTenantMode, TenantMode>

export const TENANT_MODE_TO_PRISMA = {
  live: 'LIVE',
  test: 'TEST',
} as const satisfies Record<TenantMode, PrismaTenantMode>
